import styled from 'styled-components';

import {
  Flex,
  SVG,
} from 'web-styled';

export const ActionsTrigger = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
})`
  position: relative;
  width: 20px;
  height: 30px;
  cursor: pointer;
  flex-shrink: 0;
  margin-left: auto;

  svg {
    position: absolute;
    cursor: pointer;
  }
`;

export const ContextMenu = styled(SVG.ContextMenu).attrs({
  width: 20,
  height: 30,
  stroke: '#a8a8a8',
  transform: 'scale(1.6)',
})``;
